import * as React from "react";
import { Button, Create, ReferenceInput, required, SelectInput, TextInput, Toolbar, useNotify } from "react-admin";
import { TitlesAUM } from "../Constants/Constants";
import { SourceCustomer } from "../../../Pages/Admin/Customer";
import { CircularProgress, Grid } from "@material-ui/core";
import { Form } from "react-final-form";
import { Add } from "@material-ui/icons";
import { useAppDataProvider } from "../../../dataprovider";
import { useHistory } from "react-router-dom";
import {
  AircraftUnderMaintenanceStatus,
  AircraftUnderMaintenanceType,
} from "../../../Enums/AircraftUnderMaintenanceEnums";
import { CustomDatetime } from "../../../Components/CustomDatetime";
import { useAuth } from "@airborne/react-admin";

// Form içeriğini ayrı bir component'e taşıyalım
const CreateAUMForm = ({
  handleSubmit,
  form,
  values,
  createLoading,
  customerList,
  acRegList,
  onChangeCustomer,
  user,
  props,
}) => {
  React.useEffect(() => onChangeCustomer(values?.customerId), [values?.customerId]);

  React.useEffect(() => {
    if (customerList?.length > 0 && user?.isCustomer) {
      const customerIdForUser = customerList.find(x => x.ownerCode == user?.ownerCode)?.id ?? 0;
      form.change("customerId", customerIdForUser);
    }
  }, [customerList, user, form]);

  return (
    <form>
      <>
        <Grid container spacing={2} style={{ width: "100%", padding: 30 }}>
          <Grid item xs={12} sm={6} xl={4}>
            <ReferenceInput
              label="Maintenance Type"
              source="maintenanceType"
              reference={"ParameterDefinitions"}
              filter={{ parameterGroupCode__eq: AircraftUnderMaintenanceType.GroupName }}
              sort={{ field: "id", order: "ASC" }}
              validate={[required()]}
              fullWidth
              variant="outlined"
            >
              <SelectInput optionValue="parameterValue" optionText="parameterDesc" />
            </ReferenceInput>
            <SelectInput
              source="customerId"
              choices={customerList}
              optionText="customerName"
              optionValue="id"
              label="Customer"
              variant="outlined"
              fullWidth
              alwaysOn
              validate={[required()]}
              disabled={user?.isCustomer}
            />
            <SelectInput
              disabled={!(values.customerId > 0)}
              source="acId"
              choices={acRegList}
              optionText="acReg"
              optionValue="id"
              label="AC"
              variant="outlined"
              fullWidth
              alwaysOn
              validate={[required()]}
            />
          </Grid>
          <Grid item xs={12} sm={6} xl={4}>
            <CustomDatetime
              source="scheduledStartDate"
              label="Scheduled Start Date"
              variant="outlined"
              fullWidth
              showTime
              validate={[required()]}
            />
            <CustomDatetime
              source="scheduledFinishDate"
              label="Scheduled Finish Date"
              variant="outlined"
              fullWidth
              showTime
              validate={[required()]}
            />
            <TextInput source="remark" label="Remark" multiline resettable fullWidth rows={3} variant="outlined" />
          </Grid>
          <Grid item xs={12} sm={6} xl={4}>
            <CustomDatetime source="realStartDate" label="Real Start Date" variant="outlined" fullWidth showTime />
            <CustomDatetime source="realFinishDate" label="Real Finish Date" variant="outlined" fullWidth showTime />
          </Grid>
          <Toolbar
            {...props}
            placeholder=""
            style={{
              display: "flex",
              justifyContent: "end",
              width: "100%",
            }}
          >
            <Button
              label={createLoading ? "Creating!" : "Create"}
              size="medium"
              variant="contained"
              color="primary"
              onClick={handleSubmit}
            >
              {createLoading ? <CircularProgress size="2rem" color="secondary" /> : <Add />}
            </Button>
          </Toolbar>
        </Grid>
      </>
    </form>
  );
};

const CreateAUM = props => {
  const notify = useNotify();
  const history = useHistory();
  const dataProvider = useAppDataProvider();
  const { user } = useAuth();
  const [createLoading, setCreateLoading] = React.useState<boolean>(false);
  const [acRegList, setAcRegList] = React.useState<any>([]);
  const [customerList, setCustomerList] = React.useState<any>([]);

  React.useEffect(() => {
    dataProvider
      .getList(SourceCustomer, {
        pagination: { page: 1, perPage: 9999 },
        sort: { field: "id", order: "ASC" },
        filter: {},
      })
      .then(response => {
        let data: any = response.data;
        if (data.length > 0) {
          setCustomerList(data);
        }
      })
      .catch(error => {
        console.log(error);
      });
  }, []);

  const onChangeCustomer = customerId => {
    if (!(customerId > 0)) {
      return;
    }
    var customerOwnerCode = customerList.find(x => x.id == customerId)?.ownerCode;
    if (!customerOwnerCode) {
      setAcRegList([]);
      return;
    }
    dataProvider
      .getList("cdmaircraft/FetchAcListAsync/" + customerOwnerCode, {
        filter: { IsContractStatus__eq: true },
        pagination: { page: 1, perPage: 99999 },
        sort: { field: "id", order: "DESC" },
      })
      .then(response => {
        let data: any = response?.data;
        setAcRegList([]);
        if (data.length > 0) {
          setAcRegList(data);
        }
      })
      .catch(error => {
        console.log(error);
      });
  };

  const onSubmit = values => {
    if (createLoading) {
      return;
    }
    setCreateLoading(true);
    dataProvider
      .postAircraftUnderMaintenances({ ...values, ...{ status: AircraftUnderMaintenanceStatus.Open } })
      .then(response => {
        notify(`Record created`, "success", false, true);
        history.push(`/aircraftundermaintenances`);
      })
      .catch(response => {
        notify(`${response?.response?.data?.message ?? response}`, "error", false, false);
      })
      .finally(() => {
        setCreateLoading(false);
      });
  };

  return (
    <Create {...props} title={TitlesAUM.create}>
      <Form
        onSubmit={onSubmit}
        render={({ handleSubmit, form, values }) => (
          <CreateAUMForm
            handleSubmit={handleSubmit}
            form={form}
            values={values}
            createLoading={createLoading}
            customerList={customerList}
            acRegList={acRegList}
            onChangeCustomer={onChangeCustomer}
            user={user}
            props={props}
          />
        )}
      />
    </Create>
  );
};

export default CreateAUM;
